<template>
  <VhallDialog
    :visible="visible"
    :title="$t('lang.k_391001')"
    width="400px"
    @close="closeDialog"
    class="subject-show-dialog"
  >
    <div class="tip_content" v-if="resultVo && resultVo.total == 0">{{ $t('lang.k_391002') }}</div>
    <div class="tip_content" v-else-if="resultVo && resultVo.total == 1">
      {{ $t('lang.k_391003') }}
      <span
        class="color_blue cursor_pointer"
        v-if="resultVo && resultVo.list"
        @click="goSubjectDetail(resultVo.list[0].subject_id)"
      >
        《{{ subjectTitle }}》
      </span>
      ，
      <template v-if="verifyText">
        {{ $t('lang.k_391004') }}{{ verifyText }}{{ $t('lang.k_391005') }}
        <span class="color_red">{{ $t('lang.k_391006') }}</span>
        。
      </template>
      <template v-else>{{ $t('lang.k_391007') }}</template>
    </div>
    <div class="tip_content" v-else-if="resultVo && resultVo.total > 1">
      {{ $t('lang.k_391008') }}
    </div>
    <div class="tip_content" v-else>{{ $t('lang.k_391009') }}</div>
    <div slot="footer">
      <vh-button
        type="primary"
        size="medium"
        round
        v-preventReClick
        @click.prevent.stop="closeDialog"
      >
        {{ $t('lang.k_391010') }}
      </vh-button>
    </div>
  </VhallDialog>
</template>
<script>
  export default {
    props: {
      dialogVisible: {
        type: Boolean,
        default: false
      },
      // 活动ID 或者 专题ID，跟signUpPageType字段组合使用
      webinarOrSubjectId: {
        type: [Number, String],
        default: 0
      },
      // 报名表单类型：webinar--活动；subject--专题
      signUpPageType: {
        type: [Number, String],
        default: ''
      }
    },
    data() {
      return {
        visible: false,
        resultVo: null
      };
    },
    created() {
      this.getVerifyInfo();
    },
    computed: {
      verifyText() {
        if (this.resultVo && this.resultVo.list) {
          if (this.resultVo.list[0].subject_verify == 2) {
            return this.$t('lang.k_391011');
          } else if (
            this.resultVo.list[0].subject_verify == 1 &&
            this.resultVo.list[0].verify == 1
          ) {
            return this.$t('lang.k_391012');
          } else if (
            this.resultVo.list[0].subject_verify == 1 &&
            this.resultVo.list[0].verify == 2
          ) {
            return this.$t('lang.k_391013');
          } else if (
            this.resultVo.list[0].subject_verify == 1 &&
            this.resultVo.list[0].verify == 4
          ) {
            return this.$t('lang.k_391014');
          } else if (
            this.resultVo.list[0].subject_verify == 1 &&
            this.resultVo.list[0].verify == 0
          ) {
            return this.$t('lang.k_391015');
          } else {
            return '';
          }
        } else {
          return '';
        }
      },
      subjectTitle() {
        if (this.resultVo && this.resultVo.list) {
          if (this.resultVo.list[0].title && this.resultVo.list[0].title.length > 10) {
            return this.resultVo.list[0].title.substr(0, 10) + '...';
          } else if (this.resultVo.list[0].title) {
            return this.resultVo.list[0].title;
          } else {
            return '--';
          }
        } else {
          // 无内容，默认占位
          return '--';
        }
      }
    },
    beforeDestroy(to, from, next) {
      if (this.vm) {
        this.vm.close();
      }
      if (next) {
        next();
      }
    },
    methods: {
      initAuthMessage() {
        let that = this;
        this.vm = this.$vhMessage({
          showClose: true,
          duration: 0,
          dangerouslyUseHTMLString: true,
          message:
            '<p style="color:#1A1A1A; padding-right: 12px">' +
            this.$t('lang.k_391003') +
            '《<span id="openSubjectDetails" style="color:#3562fa;cursor: pointer;">' +
            that.subjectTitle +
            '</span>》' +
            this.$t('lang.k_391004') +
            that.verifyText +
            '  ' +
            this.$t('lang.k_391016') +
            ' <span style="color:#FB3A32">' +
            this.$t('lang.k_391006') +
            '   </span></p>',
          type: 'warning'
        });
        let open = document.querySelector('#openSubjectDetails');
        open.addEventListener('click', function (e) {
          that.vm.close();
          that.goSubjectDetail();
        });
      },
      getVerifyInfo() {
        this.$fetch('getSubjectByWebinarId', {
          webinar_id: this.webinarOrSubjectId,
          pos: 0,
          limit: 2
        })
          .then(resV => {
            if (resV && resV.code == 200 && resV.data) {
              this.resultVo = resV.data;
              console.log(this.resultVo, '我是报名表单');
              if (this.resultVo && this.resultVo.total == 1 && this.verifyText) {
                this.initAuthMessage();
                this.$emit('getSubjectInfo', this.resultVo.list[0]);
              }
            } else {
              this.resultVo = null;
            }
          })
          .catch(resV => {
            console.log('获取数据失败', resV);
            this.resultVo = null;
          });
      },
      // 关闭
      closeDialog() {
        this.visible = false;
      },
      // 跳转专题界面
      goSubjectDetail() {
        window.open(
          `${window.domainOfConsole()}/special/edit/${this.resultVo.list[0].subject_id}?title=` +
            this.$t('lang.k_391017'),

          '_blank'
        );
      }
    }
  };
</script>

<style lang="less" scoped>
  .subject-show-dialog {
    .tip_content {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      min-height: 40px;
      color: #1a1a1a;
      white-space: normal;
      word-break: break-word;
      overflow-wrap: break-word;
    }
    .cursor_pointer {
      cursor: pointer;
    }
    .color_blue {
      color: #3562fa;
    }
    .color_red {
      color: #fb3a32;
    }
  }
</style>
